import React from 'react';
import { graphql } from 'gatsby';
import Image from 'gatsby-plugin-sanity-image';

import Pancake from './Pancake';
import Container from '../Container';
import PancakeIntro from '../PancakeIntro';
import Button from '../Button';
import Card from '../Card';

import './ProductTour.scss';

const ProductTour = (props) => {
  const { title, text, callToAction, image, theme } = props;

  return (
    <Pancake className="PancakeProductTour" theme={theme}>
      <Container size="Small">
        <PancakeIntro title={title} text={text} />
        <Card
          clickable={callToAction?.url && true}
          theme="Light"
          shadowLevel="Low"
        >
          <div className="PancakeProductTourThumbnail">
            <Button
              to={callToAction?.url}
              className="corporate-light full"
              arrow
            >
              {callToAction?.label}
            </Button>
            {image && (
              <Image {...image.image} width={846} alt={image.altText} />
            )}
          </div>
        </Card>
      </Container>
    </Pancake>
  );
};

export const query = graphql`
  fragment SanityPancakeProductTour on SanityPancakeProductTour {
    _key
    _type
    pancakeIntro {
      pancakeText
      pancakeTitle
    }
    theme
    callToAction {
      url
      label
    }
    image {
      image {
        ...ImageWithPreview
      }
      altText
      caption
    }
  }
`;

export default ProductTour;
